import { ReactiveMap } from "@solid-primitives/map"
import { batch, createEffect } from "solid-js"
import getWaterFlowError from "../../lib/core/Current/WaterFlowError/getWaterFlowError"
import type { WaterFlowError } from "../../lib/core/Current/WaterFlowError/WaterFlowError.type"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { createSharedTileGraphNodeCollectionMemo } from "./createSharedTileGraphNodeCollectionMemo"
import useGridWidthHeight from "./useGridWidthHeight"
import { useSharedWaterEntsWithCurrentListMemo } from "./useSharedWaterEntsWithCurrentListMemo"

// return all river water ents
export const useSharedWaterFlowErrorsMapMemo = createSharedCachedFactory((engine) => {
  const getGridSize = useGridWidthHeight(engine)
  // if a river is an exit, it should point in or out at the sea/lake/swamp/marsh
  const getTileGraphNodesList = createSharedTileGraphNodeCollectionMemo(engine)

  const map = new ReactiveMap<number, WaterFlowError>()

  const getWaterEntsWithCurrentList = useSharedWaterEntsWithCurrentListMemo(engine)

  createEffect(() => {
    const { width: gridWidth } = getGridSize()
    const tpNodeList = getTileGraphNodesList()
    const waterEntsWithCurrentList = getWaterEntsWithCurrentList()
    map.clear()

    batch(() => {
      for (const ent0 of waterEntsWithCurrentList) {
        const error = getWaterFlowError(ent0, tpNodeList, gridWidth)
        if (error) {
          const nodeIndex = ent0.x + ent0.y * gridWidth
          map.set(nodeIndex, error)
        }
      }
    })
  })

  // if (DEV) {
  //   createEffect(() => {
  //     console.log('waterFlowErrorsMap')
  //     console.table([...map.values()])
  //   })
  // }

  return map
})
